import { connect } from 'react-redux';

import BaseScreen from '../components/BaseScreen';
import { initQB, initJanus } from '../actionCreators';

const mapStateToProps = null;

const mapDispatchToProps = { initQB, initJanus };

export default connect(mapStateToProps, mapDispatchToProps)(BaseScreen);
